import { useNavigate } from "react-router-dom";
import { LayoutDashboard, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_guest-retreat-finder/artifacts/ymwgc3ta_Logo%20Quattro%20Accommodations.png";

export default function OwnerLayout({ children, title }) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/owner/login"); };

  return (
    <div className="min-h-screen bg-brand-canvas">
      <header className="sticky top-0 z-30 bg-brand-violet text-white">
        <div className="max-w-6xl mx-auto flex items-center justify-between gap-4 px-4 sm:px-6 h-16">
          <div className="flex items-center gap-3 min-w-0">
            <img src={LOGO} alt="Quattro" className="h-8 w-auto object-contain bg-white/95 rounded-lg p-1" />
            <span className="hidden sm:flex items-center gap-2 text-sm font-medium text-white/80">
              <LayoutDashboard size={16} className="text-brand-teal" /> Area Proprietario
            </span>
          </div>
          <div className="flex items-center gap-2">
            <a href="/" target="_blank" rel="noreferrer" className="hidden sm:flex items-center gap-1.5 text-sm text-white/60 hover:text-brand-teal px-3">
              <ExternalLink size={15} /> Portale
            </a>
            <span className="hidden md:block text-xs text-white/40 truncate max-w-[160px]">{user?.email}</span>
            <Button onClick={doLogout} data-testid="owner-logout-btn" variant="ghost" size="sm" className="text-white/80 hover:text-white hover:bg-white/10">
              <LogOut size={16} className="mr-1.5" /> Esci
            </Button>
          </div>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        {title && <h1 className="font-serif text-2xl md:text-3xl text-brand-plum mb-6" data-testid="owner-page-title">{title}</h1>}
        {children}
      </div>
    </div>
  );
}
